import { Icon } from 'components/Icon';
import { EIcon } from 'configs/constants';
import React from 'react';

interface ISearchbar {
	placeholder?: string;
	value?: string;
	onChange: (value: string) => void;
}

export const Searchbar = (props: ISearchbar) => {
	const { placeholder, value, onChange } = props;

	return (
		<div className="flex items-center px-4 py-2 mb-4 border rounded-lg border-primary-500">
			<Icon name={EIcon.Search} className="text-primary-500" />
			<input
				className="flex-1 ml-2 text-primary-500"
				value={value}
				placeholder={placeholder}
				onChange={(e) => onChange(e.currentTarget.value)}
			/>
		</div>
	);
};
